import { InputContainer } from 'styles'
import { ChangeEvent, useState, useRef, useEffect } from 'react'
import { Icon } from 'assets/index'
import { useField } from '@unform/core'
import { Input, Span, InputError } from './style'

interface IInputProps {
  type: string
  // error?: any
  name: string
  placeholder?: string
  disabled?: boolean
  value?: string
  maxLength?: number
  onChange?: (_e: ChangeEvent<HTMLInputElement>) => void
  initialError?: string
  secondary?: boolean
}

export default function InputComponent(props: IInputProps) {
  const { name, maxLength, type, placeholder, value, secondary } = props
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const inputRef = useRef<any>(null)
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name)

  // useEffect(() => {
  //   inputRef.current.value = null
  // }, [])

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.value
      },
      setValue: (ref, evalue) => {
        ref.current.value = evalue
      },
      clearValue: (ref) => {
        ref.current.value = ''
      },
    })
  }, [fieldName, registerField])

  const handleChangeState = () => {
    setShowPassword((oldState) => {
      return !oldState
    })
  }

  return (
    <InputContainer>
      <Input
        error={error}
        ref={inputRef}
        placeholder={placeholder}
        {...props}
        maxLength={maxLength}
        name={name}
        type={showPassword ? 'text' : type}
        defaultValue=""
        value={value}
        onFocus={clearError}
      />
      <Span secondary={secondary} empty={value === ''}>
        {placeholder}
      </Span>
      {type === 'password' ? (
        <img
          className="password-icon"
          src={showPassword ? Icon('lock_closed.svg') : Icon('lock_open.svg')}
          alt="password lock icon"
          onClick={handleChangeState}
        />
      ) : null}
      {error && <InputError>{error}</InputError>}
    </InputContainer>
  )
}
